var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVbo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.089 12L11.9895 21.6385",
    stroke: "#262D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6145 16.4372V7.56241C20.6145 7.4296 20.5792 7.29917 20.5123 7.18445C20.4454 7.06973 20.3492 6.97485 20.2335 6.90949L12.3585 2.45841C12.246 2.39477 12.1188 2.36133 11.9895 2.36133C11.8602 2.36133 11.733 2.39477 11.6205 2.45841L3.74546 6.90949C3.62983 6.97485 3.53364 7.06973 3.4667 7.18445C3.39977 7.29917 3.3645 7.4296 3.3645 7.56241V16.4372C3.3645 16.57 3.39977 16.7005 3.4667 16.8152C3.53364 16.9299 3.62983 17.0248 3.74546 17.0901L11.6205 21.5412C11.733 21.6049 11.8602 21.6383 11.9895 21.6383C12.1188 21.6383 12.246 21.6049 12.3585 21.5412L20.2335 17.0901C20.3492 17.0248 20.4454 16.9299 20.5123 16.8152C20.5792 16.7005 20.6145 16.57 20.6145 16.4372V16.4372Z",
    stroke: "#262D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5117 7.18365L12.0889 11.9999L3.46777 7.18262",
    stroke: "#262D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbo);
export default __webpack_public_path__ + "static/media/VBO.41203054b916628ad4e50bc4829c77db.svg";
export { ForwardRef as ReactComponent };